function tw_keep_customer_locale_up_to_date() {
    const locale = window.Shopify.locale || 'nl';

    if (!window.tw_shopify_customer_id) return; // Only logged-in customers

    async function updateCustomerLocale() {
        // Fetch current latest_locale from metafield
        const response = await fetch(`/apps/get-customer-metafield?customer_id=${window.tw_shopify_customer_id}&key=custom.latest_locale`);
        const data = await response.json();

        if (data.value !== locale) {
            // Only update if it’s different
            await fetch(`/apps/update-customer-metafield`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                customer_id: window.tw_shopify_customer_id,
                key: 'custom.latest_locale',
                value: locale
            })
            });
        }
    }
    updateCustomerLocale();
}
document.addEventListener('DOMContentLoaded', tw_keep_customer_locale_up_to_date);